(() => {
  const initialiseFlooringQuotes = (root = document) => {
    root.querySelectorAll('[data-wwfs-flooring-quote-dialog]').forEach((dialog) => {
      if (dialog.dataset.wwfsReady === 'true') return;
      dialog.dataset.wwfsReady = 'true';

      const closeDialog = () => {
        if (dialog.open) dialog.close();
        document.body.classList.remove('wwfs-flooring-quote-open');
      };

      dialog.querySelector('[data-wwfs-flooring-quote-close]')?.addEventListener('click', closeDialog);
      dialog.addEventListener('close', () => document.body.classList.remove('wwfs-flooring-quote-open'));
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      if (dialog.querySelector('[data-wwfs-flooring-quote-success]')) {
        dialog.showModal();
        document.body.classList.add('wwfs-flooring-quote-open');
      }
    });

    root.querySelectorAll('[data-wwfs-flooring-quote-open]').forEach((button) => {
      if (button.dataset.wwfsReady === 'true') return;
      button.dataset.wwfsReady = 'true';
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.wwfsFlooringQuoteOpen);
        if (!dialog) return;
        dialog.showModal();
        document.body.classList.add('wwfs-flooring-quote-open');
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseFlooringQuotes(), { once: true });
  } else {
    initialiseFlooringQuotes();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseFlooringQuotes(event.target));
})();
